import { useQuery } from '@tanstack/react-query';
import type { inferOutput } from '@trpc/tanstack-react-query';
import { useTRPC } from '../../../../lib/trpc';

type TRPC = ReturnType<typeof useTRPC>;
export type PerformanceReport = inferOutput<TRPC['performanceReport']['report']>;
export type CreativeCard = PerformanceReport['top'][number];
export type FatiguedCard = PerformanceReport['fatigued'][number];
export type HookScoreCard = PerformanceReport['hookScore'][number];
export type GroupedTags = PerformanceReport['topTags'];
export type TagCount = GroupedTags['core'][number];

export interface ReportRequest {
  dateRange: [string, string];
  creativeType: string[];
  campaignNames: string[];
  kpi: string;
  accountIds: number[];
}

export function usePerformanceReport(request: ReportRequest) {
  const trpc = useTRPC();
  const filters = {
    ...(request.creativeType.length > 0 ? { creativeType: request.creativeType } : {}),
    ...(request.campaignNames.length > 0 ? { campaignName: request.campaignNames } : {}),
  };
  return useQuery({
    ...trpc.performanceReport.report.queryOptions({
      dateRange: request.dateRange,
      kpi: request.kpi,
      ...(Object.keys(filters).length > 0 ? { filters } : {}),
      ...(request.accountIds.length > 0 ? { accountIds: request.accountIds } : {}),
    }),
    // Before the client list resolves accountIds is empty, which the server reads as "every
    // account" — an expensive query and a flash of an unscoped report.
    enabled: request.kpi.length > 0 && request.accountIds.length > 0,
  });
}
